export default {
  getConsentForm: (state) => state.consentFormInfo,
  isFormSubmitting: (state) => state.isSubmitting,
  isSubmissionCompleted: (state) => state.submissionCompleted,
};
